import { getResolvedTenantCode } from 'config/resolvedTenant';
import { STORAGE_KEYS } from 'constants/storageKeys';

const refreshByTenant = new Map<string, string>();

const resolveKey = (tenantCode?: string | null): string => {
  const code = (tenantCode ?? getResolvedTenantCode() ?? '').trim().toLowerCase();
  return code || '__default__';
};

/** Removes legacy refresh tokens persisted in localStorage (XSS mitigation migration). */
export const clearPersistedRefreshTokens = (): void => {
  try {
    const legacy = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    if (legacy) {
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    }
    const prefix = `${STORAGE_KEYS.REFRESH_TOKEN}__`;
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch {
    // ignore storage access errors
  }
};

export const sessionRefreshStore = {
  get: (tenantCode?: string | null): string | null => {
    return refreshByTenant.get(resolveKey(tenantCode)) ?? null;
  },

  set: (refreshToken: string, tenantCode?: string | null): void => {
    const trimmed = refreshToken?.trim();
    if (!trimmed) {
      sessionRefreshStore.clear(tenantCode);
      return;
    }
    refreshByTenant.set(resolveKey(tenantCode), trimmed);
  },

  clear: (tenantCode?: string | null): void => {
    refreshByTenant.delete(resolveKey(tenantCode));
  },

  clearAll: (): void => {
    refreshByTenant.clear();
  },
};
